import {store} from "../../../store/store";
import {StorageUtil} from '../../../common/Auth.js';
 export default {
  name:'setup',
  data(){
    return{
      user: null,
    }
  },
  beforeMount() {
    store.personal._this.activeNav = "设置";
    this.user = store.func.getUserObj();
  },
   computed: {
     libraryName() {
       return this.$route.query.hallCode || '';
     },
   },
     methods:{
       logout() {
         StorageUtil.storeString("token", null);
         StorageUtil.storeObject("user", null);
         store.user = null;
         store.token = "";
         store.wrap.user = null;
         location.reload();
       },
     }
}
